<template>
  <div>
    <h1>Pagina de Ejemplo</h1>
    <example-test v-if="false" />
    <example-table-test v-if="false" />
    <example-draggable v-if="false" />
    <plottly-test v-if="true" />
    <example-v-tool-tip v-if="false" />
    <time-line-plottly-test v-if="false" />
    <example-store v-if="false" />
    <example-excel-js v-if="false" />
  </div>
</template>

<script>
import ExampleTest from '../components/examples/ExampleTest'
import ExampleTableTest from '../components/examples/ExampleTableTest'
import ExampleDraggable from '../components/examples/ExampleDraggable'
import PlottlyTest from '../components/examples/PlottlyTest'
import ExampleVToolTip from '../components/examples/ExampleVToolTip'
import TimeLinePlottlyTest from '../components/examples/TimeLinePlottlyTest'
import ExampleExcelJs from '../components/examples/ExampleExcelJs'
export default {
  name: 'Home',
  components: {
    ExampleTest,
    ExampleTableTest,
    ExampleDraggable,
    PlottlyTest,
    ExampleVToolTip,
    TimeLinePlottlyTest,
    ExampleExcelJs
  }
}
</script>
